var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "32", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm0 1.467a9.533 9.533 0 1 0 0 19.067 9.533 9.533 0 0 0 0-19.067z", fill: "#050505" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.371 9.961c-1.068-.126-1.387.152-1.382 1.318l3.685 3.513 8.293-7.466c-.05-1.112-.333-1.424-1.382-1.318l-6.91 6.149L7.37 9.961z", fill: "#050505" })
  );
});